// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Cardiovascular = {
  productCode: "SBOVZ-ASC",
  productName: "Garlic Vitamer Complex (AlliciB6-PoB)",
  ingredients: "Allium sativum",
  overview:"",
  assay:"Natural Thiamine: 2.5 %; Natural Pyridoxine: 3.5 %",
  coNutrients:"Incidental nutrients include water-soluble antioxidant compounds. 5-hydroxymethylfurfural, selenium, iron, sodium and calcium (not a claim), Fructans and other polyphenol, other volatile compounds.",
  studies:"Epidemiologic evidence on the interactions between garlic compounds as well as microbes and its affect on SCFAs and prebiotic mechanism. Variances in extract preparation methods to understand unknown active substances, and their bioavailability.",
  benefits:"Garlic is a source of organosulfur compounds L-cysteine sulfoxides and γ-glutamyl L-cysteine peptides which has numerous health benefits with more than 20 bioactive compounds and eight essential amino acids.  Consumption of garlic improves gut microbial profile. Mature garlic bulb contains water-soluble organosulfur compounds S allylmercaptocysteine and S -allyl cysteine. Garlic-derived organosulfur compounds exhibit anti-inflammatory activity by inhibiting the mediators of the inflammatory response, including cytokines and chemokines, inhibits enzymes in the cholesterol bio synthesis pathway. ",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Garlic-1.png",
    "images/Portfolio/OrgavitazForConditions/Garlic-2.png"

    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",

  ]
};

export default Cardiovascular;
